import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: "/impressum",
    name: "impressum",
    component: () => import('@/views/Impressum.vue')
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: () => import('@/views/Datenschutz.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
